import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./VideoPlayer.css";

const VideoJSPlayer = ({ videoObject }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) {
      playerRef.current = videojs(videoRef.current, {
        controls: true,
        responsive: true,
        fluid: false,
        fill: true,
      });
    }

    playerRef.current.src({
      src: videoObject.hlsUrl,
      type: "application/x-mpegURL",
    });

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [videoObject]);

  return (
    <Box sx={styles.container}>
      <div data-vjs-player>
        <video
          ref={videoRef}
          className="video-js vjs-fill vjs-default-skin"
          style={styles.video}
          preload="none"
          poster={videoObject.thumbNailsUrls?.[0]} // 👈 add this line
        />
      </div>
    </Box>
  );
};

const styles = {
  container: {
    fontFamily: "VideoJS !important",
    fontFace: "VideoJS !important",
    height: { xs: 260, sm: 360, md: 320 },
    borderRadius: 1,
    overflow: "hidden",
  },
  video: {
    fontFamily: "VideoJS !important",
    fontFace: "VideoJS !important",
    // minHeight: 300,
    minWidth: 300,
    // minHeight: { xs: 260, sm: 360, md: 320 },
    width: "100%",
    objectFit: "contain",
  },
};

export default VideoJSPlayer;
